import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  selectItem: {
    display: 'flex',
    flexDirection: 'column',
  },
  accountNumber: {
    fontSize: 14,
    color: theme.custom.darkBlue,
    fontWeight: 600,
  },
  operatorName: {
    fontSize: 14,
    color: theme.custom.darkBlue,
  },
  output: {
    fontSize: 16,
    color: '#fff',
  },
  mobileSelect: {
    [theme.breakpoints.down(490)]: {
      width: '100%',
      justifyContent: 'space-between',
      marginBottom: 20,
    },
  },
}));
